import React from 'react';
import { decodeProfileValues } from '@pkgs/api/utils';
import { Headline } from '@ev-tech/ui-core-components/Headline';

import { useListing } from '@/hooks/queries/useListing';

import styles from './StickyHeader.module.css';

export const ListingTitle = () => {
  const {
    data: { listing },
  } = useListing();

  if (!listing) return null;

  const { title } = decodeProfileValues(listing.profile);

  return <Headline className={styles.title} label={title} size="h6" as="p" />;
};
